import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import * as Yup from 'yup';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import Iconify from '../../components/Iconify';
import {
    Grid, Card, IconButton, InputAdornment, Container, FormControl, FormHelperText, InputLabel, Select, MenuItem, TextField, Chip, OutlinedInput, Box,
    FormGroup,FormControlLabel,Checkbox,Autocomplete
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
// @mui
import Page from '../../components/Page';
import { CreateSubadminAction, ResetCreateSubadminAction } from 'src/redux/actions/SubadminAction';
import { toast } from 'react-toastify';
import moment from 'moment';
import { SendNotificationAction } from 'src/redux/actions/NotificationAction';
import { GetUserListAction } from 'src/redux/actions/UsersAction';
// ----------------------------------------------------------------------

export default function NotificationCreate() {
    let params1=null;
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const isLoading = useSelector(state => state.notification.loading)
    const createNotifySelector = useSelector(state => state.notification.send_msg)
    const [showPassword, setShowPassword] = useState(false);
    const [accessModuleArr, setAccessModuleArr] = useState([])
    const [personName, setPersonName] = useState([]);
    const [dropChk, setDropChk] = useState("");
    const UserList = useSelector((state) => state.users.user_list.data);
    const USERLIST = UserList !== undefined && UserList.data.users;
    const [multiUser, setMultiUser] = useState();

    console.log("USERLIST-->>",USERLIST);

    const handleMultiSelectOnChange = (event) => {
        const {
            target: { value },
        } = event;
        setPersonName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const NewUserSchema = Yup.object().shape({
        type: Yup.string().required('Type is Required'),
        title: Yup.string().min(5).max(20).required('Title is Required'),
        body: Yup.string().min(10).max(48).required('Body is Required'),
    });

    const formik = useFormik({
        initialValues: {
            userids:[],
            enddate: '',
            title: '',
            body: ''
        },
        validationSchema: NewUserSchema,
        onSubmit: (value) => {
            console.log("valuevalue===>>",value,multiUser);
            let {enddate,type,title,body}=value;
            let isexpire=(dropChk=="forever")?0:1;
            let userArr=[];
            if(multiUser && multiUser.length>0){
             multiUser.map(item=>userArr.push(item["id"]))
            }else{
                userArr=[];
            }
            dispatch(SendNotificationAction({userids:userArr,enddate,isexpire,type,title,body}))
        }
    });

    const handleShowPassword = () => {
        setShowPassword((show) => !show);
    };

    const { errors, touched, values, isSubmitting, handleChange, handleSubmit, getFieldProps } = formik;

   

    useEffect(() => {
        if (Object.keys(createNotifySelector).length > 0) {
            if (createNotifySelector?.status) {
                toast.success(createNotifySelector.message, { theme: "colored" })
                navigate(`/dashboard/notification/list`)
                setAccessModuleArr([])
                dispatch(ResetCreateSubadminAction())
            }
            else {
                toast.error(createNotifySelector.message, { theme: "colored" })
                dispatch(ResetCreateSubadminAction())
            }
        }
    }, [createNotifySelector])

const multipleSelect=[
    {id:"promotion",name:"Promotion"},
    {id:"win",name:"Win"},
    {id:"refund",name:"Refund"}
    ,{id: "promocode",name: "Promocode"}
    ,{id: "long_time_join",name: "User Long Time Join"}
]

const stateHandler = (key) => {
    setDropChk(key);
};

useEffect(() => {
    dispatch(GetUserListAction(1,22000,3,{ devicetoken:true}));
}, [dispatch]);


  const onChangeUserList=(event, values)=>{
    console.log("e===>>",event,values)
    setMultiUser(values);
  }

  console.log("MultiUser-->>",multiUser)

    return (
        <Page title="Create Subadmin">
            <Container maxWidth="lg">
                <HeaderBreadcrumbs
                    heading="Create"
                    links={[
                        { name: "Dashboard", href: "/dashboard/app" },
                        { name: "Notification", href: "/dashboard/notification/list" },
                        { name: "Create" },
                    ]}
                />

                <Card sx={{ py: 5, px: 3 }}>
                    <FormikProvider value={formik}>
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Grid container spacing={3}>
                                
                             <Grid item xs={12} md={6} lg={4}>
                                    <FormControl fullWidth>
                                        <InputLabel id="select-grender"> Select Type </InputLabel>
                                        <Select
                                            labelId="select-grender"
                                            onChange={handleChange}
                                            label="Type"
                                            // name="gender"
                                            // defaultValue=""
                                            {...getFieldProps('type')}
                                            error={Boolean(touched.type && errors.type)}
                                            helperText={touched.type && errors.type}
                                        >
                                            {multipleSelect.map((item)=><MenuItem value={item.id}> {item.name} </MenuItem>)}
                                            
                                        </Select>
                                        {touched.type &&
                                            <FormHelperText style={{ color: "#FF4842" }}>{errors.type}</FormHelperText>
                                        }

                                    </FormControl>
                                </Grid> 
                                <Grid item xs={12} md={6} lg={3}>
                                            <FormGroup>
                                                <FormControlLabel control={
                                                    <Checkbox name="makeContestConfirmed" checked={dropChk=="forever"} onChange={({ target }) => stateHandler("forever")} />
                                                } label="Notice forever." />
                                                <FormControlLabel control={
                                                    <Checkbox name="teamType" checked={dropChk=="donot"} onChange={({ target }) => stateHandler("donot")} />
                                                } label="Notice End at" />
                                            </FormGroup>
                                        </Grid>
                                <Grid item xs={12} md={6} lg={4}>
                                    {dropChk=="donot" && <TextField
                                        fullWidth
                                        type="date"
                                        placeholder="End Date"
                                        {...getFieldProps('enddate')}
                                        error={Boolean(touched.enddate && errors.enddate)}
                                        helperText={touched.enddate && errors.enddate}
                                    />}
                                </Grid>
                                
                                <Grid item xs={12}>
                                    <FormControl fullWidth >
                                        <InputLabel id="access-module-select" shrink>Users</InputLabel>
                                        <Autocomplete
                                            multiple
                                            id="tags-outlined"
                                            options={USERLIST}
                                            getOptionLabel={(option) =>option.email}
                                            //defaultValue={[USERLIST[13]]}
                                            filterSelectedOptions
                                            onChange={onChangeUserList}
                                            renderInput={(params) => {
                                                
                                                if(params){
                                                    params1=params;
                                                }
                                                
                                                return(
                                            <TextField
                                                {...params}
                                                label="Users"
                                                placeholder="Users"
                                            />
                                            )}}
                                        />
                                        

                                    </FormControl>
                                </Grid>
                                
                                <Grid item xs={12} md={6} lg={4}>
                                    <TextField
                                        fullWidth
                                        type="text"
                                        label="Title"
                                        {...getFieldProps('title')}
                                        error={Boolean(touched.title && errors.title)}
                                        helperText={touched.title && errors.title}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControl fullWidth >
                                        <TextField
                                            fullWidth
                                            id="outlined-multiline-static"
                                            label="Body"
                                            multiline
                                            rows={4}
                                            {...getFieldProps('body')}
                                            error={Boolean(touched.body && errors.body)}
                                            helperText={touched.body && errors.body}
                                        />
                                       
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12}>
                                    <LoadingButton type="submit" variant="contained" loading={false}>
                                        Submit
                                    </LoadingButton>
                                </Grid>
                            </Grid>
                        </Form>
                    </FormikProvider>
                </Card>
            </Container>
        </Page>
    );
}
